/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_WORK_GROUPS } from '../../actions.type'
import {
  CREATE_WORK_GROUP,
  REMOVE_WORK_GROUP,
  SET_WORK_GROUP_ALL_REQUEST,
  SET_WORK_GROUP_ALL_VALUE,
  UPDATE_WORK_GROUP
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  workGroupAllValue: (state) => state.all.value,
  workGroupAllRequest: (state) => state.all.request,
  workGroupAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_WORK_GROUPS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('work-group', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_WORK_GROUP_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_WORK_GROUP_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_WORK_GROUP_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_WORK_GROUP_ALL_VALUE, data)
    } catch (e) {
      commit(SET_WORK_GROUP_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_WORK_GROUP({ commit }, value) {
    commit(CREATE_WORK_GROUP, value)
  },

  async SOCKET_UPDATE_WORK_GROUP({ commit }, value) {
    commit(UPDATE_WORK_GROUP, value)
  },

  async SOCKET_REMOVE_WORK_GROUP({ commit }, id) {
    commit(REMOVE_WORK_GROUP, id)
  }
}

const mutations = {
  [SET_WORK_GROUP_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_WORK_GROUP_ALL_VALUE](state, workGroups) {
    state.all.value = workGroups
  },
  [UPDATE_WORK_GROUP](state, updatedWorkGroup) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedWorkGroup.id }),
      1,
      updatedWorkGroup
    )
  },
  [CREATE_WORK_GROUP](state, createdWorkGroup) {
    state.all.value.push(createdWorkGroup)
  },
  [REMOVE_WORK_GROUP](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
